import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;
export const Content = styled.div `
  overflow: hidden auto;
  height: 100%;
`;
export const InnerContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${themeGet('spacing.xl')};
  padding: ${themeGet('spacing.2xl')};
`;
export const ActionsFooter = styled.div `
  padding: ${themeGet('spacing.xl')};
  border-top: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
`;
